import { grantList, grantCreate, grantResend, grantCancel } from '@/services/wallPixelGrants.service'

export default {
	namespaced: true,
	state: {
		grantList: {
			meta: { pagination: { total: 0 } },
			data: [],
		},
		grantListStatus: 'init',
		grantSaveStatus: 'init',
	},
	getters: {
		getGrantList: state => state.grantList,
		getGrantListStatus: state => state.grantListStatus,
		getGrantSaveStatus: state => state.grantSaveStatus,
	},
	mutations: {
		GRANT_LIST(state, value) { state.grantList = value },
		GRANT_LIST_STATUS(state, value) { state.grantListStatus = value },
		GRANT_SAVE_STATUS(state, value) { state.grantSaveStatus = value },
	},
	actions: {
		async fetchGrants({ commit }, params) {
			commit('GRANT_LIST_STATUS', 'pending')
			try {
				const res = await grantList(params)
				commit('GRANT_LIST', res.data)
				commit('GRANT_LIST_STATUS', 'init')
			} catch {
				commit('GRANT_LIST_STATUS', 'error')
			}
		},
		async createGrant({ commit }, data) {
			commit('GRANT_SAVE_STATUS', 'pending')
			try {
				const res = await grantCreate(data)
				commit('GRANT_SAVE_STATUS', 'init')
				return res
			} catch (err) {
				commit('GRANT_SAVE_STATUS', 'error')
				throw err
			}
		},
		async resendGrant(_, id) {
			return grantResend(id)
		},
		async cancelGrant(_, id) {
			return grantCancel(id)
		},
	},
}
